/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext } from 'react';
import { BeneficiariesDataContext } from '../contexts/BeneficiariesDataContext';
import { getBeneficiariesList } from '../services/service';
import { CorporateClub } from '../contexts/types/corpclub-type';
import useFilterData from './useFilterData';

interface CorporateClubList {
  corporateClubList?: CorporateClub[];
  lastPage?: string;
}

export const useBeneficiariesData = () => {
  const {
    states: {
      beneficiariesData: { setter: setBeneficiariesData },
    },
  } = useContext<any>(BeneficiariesDataContext);

  const {
    selectedContractedPlan,
    selectedAvailablePlan,
    selectedStartDate,
    selectedEndDate,
    startRowNum,
    search,
    setLoading,
  } = useFilterData();

  const getStartDate = selectedStartDate?.format().split('T')[0];
  const getEndDate = selectedEndDate?.format().split('T')[0];

  const getBeneficiariesCorpClub = async () => {
    const getBeneficiaries: CorporateClubList = await getBeneficiariesList({
      currentPlanList: String(selectedContractedPlan),
      availablePlans: String(selectedAvailablePlan),
      search,
      createdStart: getStartDate,
      createdEnd: getEndDate,
      pageSize: '100',
      startRowNum: String(startRowNum),
    }).then((resp) => resp);
    setBeneficiariesData(getBeneficiaries?.corporateClubList);
    setLoading(false);
  };

  return { getBeneficiariesCorpClub };
};
